import { gql } from '@/__generated__';

export const REMOVE_DEVICE_TAG = gql(`#graphql
  mutation RemoveDeviceTag($input: RemoveDeviceTagInput!) {
    removeDeviceTag(input: $input) {
      device {
        id
        profile {
          id
          tags {
            tag
            attributes
          }
        }
      }
    }
  }
`);
